/// <amd-module name="Pipeline/Analytics/PipelineOutcome/PipelineOutcomeHub/Sources/PipelineOutcomeHubSource" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { IPipelineOutcomeReportConfiguration } from "Pipeline/Analytics/Common/Types";
import { IPipelineOutcomeData } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomeReportSource } from "Pipeline/Analytics/PipelineOutcome/Common/Sources/PipelineOutcomeReportSource";
import { IPipelineOutcomeTaskFailureData } from "Pipeline/Analytics/PipelineOutcome/Common/Types";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeHubSource extends PipelineOutcomeReportSource {
    constructor(pageContext: IVssPageContext) {
        super("PipelineAnalytics_OutcomeHub", pageContext);
    }

    public queryPipelineTrendData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<IPipelineOutcomeData> {
        return super.queryPipelineSummaryAndTrendData(reportContext, confValues);
    }
}
